import { Confirm, CustomDialog } from "react-st-modal";
import { ListItemIcon, MenuItem } from '@mui/material';
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
import OPERATIONS_EXPENSE_CONCEPT from "./op_expense_concept";
import { expenses_concept_delete } from "../../../services/expenses/concept";
import { findInObjectDisplayRole } from "../../../Content/verify_role";
import Details from "../../../imgComponents/lupa.png";
import Edit from "../../../imgComponents/save.png";
import Delete from "../../../imgComponents/borrar.png";

const RENDER_ROW_ACTION_MENU_ITEMS = (props) => {

    const DeleteSector = async () => {
        props.setmodalT(true);
        try {
            var rf_token = await refresh_token();
            if (rf_token === true) {
                setTimeout(async () => {
                    try {
                        const d = expenses_concept_delete(props?.row?.original?.id);
                        console.log(d);
                        props.alertas("Catálogo de Conceptos de Gastos Eliminado", true);
                        props.setmodalT(false);
                        props.handleSubmit();
                    } catch (err) {
                        props.setmodalT(false);
                        props.alertas("Error, no se pudo eliminar el Catálogo de Conceptos de Gastos", false);
                    }
                }, 1000);
            } else { }
        } catch (err) {
            console.log(err);
        }
    }


    return (
        <div>
            <MenuItem
                key={1}
                style={{ "cursor": "pointer", display: findInObjectDisplayRole(["PU:EC1", "PU:EC3"]) }}
                onClick={async () => {
                    props.closeMenu();
                    const result = await Confirm('¿Esta usted seguro de eliminar el catálogo de conceptos de gastos?', 'Eliminar Catálogo de Conceptos de Gastos', 'Si', 'No');
                    if (result) {
                        DeleteSector()
                    }
                }
                }
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={Delete}
                        title="Eliminar Catálogo de Conceptos de Gastos"
                    ></img>
                </ListItemIcon>
                Eliminar Catálogo de Conceptos de Gastos
            </MenuItem>
            <MenuItem
                key={2}
                style={{ "cursor": "pointer", display: findInObjectDisplayRole(["PU:EC2", "PU:EC3"]) }}
                onClick={async () => {
                    props.closeMenu();
                    await CustomDialog(
                        <OPERATIONS_EXPENSE_CONCEPT
                            operation={"EDIT"}
                            row={props?.row}
                            handleSubmit={props?.handleSubmit}
                            alertas={props?.alertas}
                            setmodalT={props?.setmodalT}
                        />,
                        {
                            className: "custom-modal",
                            title: "EDITAR CATALOGO DE CONCEPTOS GASTOS",
                            showCloseIcon: true,
                        }
                    );
                }
                }
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={Edit}
                        title="Editar Catálogo de Conceptos de Gastos"
                        className=""
                    ></img>
                </ListItemIcon>
                Editar Catálogo de Conceptos de Gastos
            </MenuItem>
            <MenuItem
                key={3}
                style={{ "cursor": "pointer", display: findInObjectDisplayRole(["PU:EC2", "PU:EC3"]) }}
                onClick={async () => {
                    props.closeMenu();
                    sessionStorage.setItem("id_catalogo", props?.row?.original?.id);
                    sessionStorage.setItem("nombre_catalogo", props?.row?.original?.catalog_name)
                    window.location = "/consult_assigned_concepts_v2";
                }
                }
                sx={{ m: 0 }}
            >
                <ListItemIcon>
                    <img
                        alt=""
                        src={Details}
                        title="Conceptos Asignados"
                        className=""
                    ></img>
                </ListItemIcon>
                Conceptos Asignados
            </MenuItem>

        </div >
    );
};

export default RENDER_ROW_ACTION_MENU_ITEMS;
